import React, { useEffect, useState } from "react";
import { Download, Receipt as ReceiptIcon } from "lucide-react";
import api, { API } from "../lib/api";
import { formatFCFA, formatDate } from "../lib/format";
import { PageHeader, Spinner, MethodBadge, EmptyState } from "../components/common";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

export default function Receipts() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/receipts").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (!items) return <Spinner />;

  return (
    <div>
      <PageHeader title="Recus de paiement" subtitle="Recus officiels numerotes, generes a la validation de chaque paiement." />
      <Card className="p-0 overflow-hidden">
        {items.length === 0 ? (
          <EmptyState icon={ReceiptIcon} title="Aucun recu" hint="Les recus sont crees apres validation d'un paiement." />
        ) : (
          <Table>
            <TableHeader>
              <TableRow className="bg-slate-50 hover:bg-slate-50">
                <TableHead className="px-6 py-4">N° Recu</TableHead>
                <TableHead>Client</TableHead>
                <TableHead>Methode</TableHead>
                <TableHead>Date</TableHead>
                <TableHead className="text-right">Montant</TableHead>
                <TableHead className="text-right px-6">PDF</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {items.map((r) => (
                <TableRow key={r.id} data-testid={`table-row-${r.id}`}>
                  <TableCell className="px-6 py-4 font-mono font-medium text-teal-700">{r.number}</TableCell>
                  <TableCell className="font-medium text-slate-800">{r.customer_name}</TableCell>
                  <TableCell><MethodBadge method={r.method} /></TableCell>
                  <TableCell className="text-slate-500">{formatDate(r.created_at)}</TableCell>
                  <TableCell className="text-right font-mono font-semibold">{formatFCFA(r.amount)}</TableCell>
                  <TableCell className="text-right px-6">
                    <Button size="sm" variant="outline" data-testid={`receipt-pdf-${r.id}`} onClick={() => window.open(`${API}/receipts/${r.id}/pdf`, "_blank")}>
                      <Download className="h-4 w-4" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
    </div>
  );
}
